import {CanActivate, Router} from '@angular/router';
import {Injectable, inject} from '@angular/core';
import {CookieService} from "ngx-cookie-service";
import {environment} from "../../../../environment";

@Injectable()
export class LoggedInGuardService implements CanActivate {
    private router = inject(Router);
    private cookieService = inject(CookieService);


  canActivate(): boolean {
    if (environment.keycloak) {
      this.router.navigate(['/']);
      return false;
    }
    if (this.cookieService.get('is_logged_in')) {
      this.router.navigate(['/'])
      return false;
    } else {
      return true;
    }
  }

}
